module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/hero_image@2x.362b064.png";